import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useCustomerNavigate } from 'hooks/useCustomerNavigate';

export function FallbackRedirect() {
  const navigate = useCustomerNavigate();
  const location = useLocation();

  useEffect(() => {
    navigate(location.pathname);
  }, [navigate, location.pathname]);

  return null;
}
